"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MediaLinkRenderer = {
    renderV1(link) {
        return {
            type: "Link.media",
            value: {
                ...(link.text && { text: link.text }),
            },
        };
    },
    renderV2(def, link) {
        return {
            link_type: "Media",
            ...(def.allowText && link.text && { text: link.text }),
        };
    },
    renderMocks(def, link) {
        return this.renderV2(def, link);
    },
};
exports.default = MediaLinkRenderer;
